export default {"src":"/_next/static/media/logo-black.5aeff9d1.svg","height":177,"width":902,"blurWidth":0,"blurHeight":0};